import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import { colors, devices } from 'styles';

export const ResourcesText = styled(Typography)`
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #348EE9;
  text-transform: uppercase;
`;

export const ResourcesTitle = styled(Typography)`
  margin: 16px 0 24px;
  font-weight: 700;
  line-height: 120%;
  color: ${colors.mainDark};
  font-size: 32px;
  text-align: center;

  @media (${devices.md}) {
    font-size: 36px;
  }
`;

export const ResourcesDescription = styled(Typography)`
  font-size: 18px;
  line-height: 150%;
  color: ${colors.mainDark};
  text-align: center;
  max-width: 768px;
  width: 100%;
`;
